import React from "react";

const ShimmerRow = ({ i }) => (
  <div
    style={{
      display: "flex",
      padding: "18px 0",
      borderBottom: "1px solid var(--bdr2)",
      opacity: 1 - i * 0.1,
    }}
  >
    <div style={{ width: 52 }} />
    <div style={{ flex: 1, paddingRight: 16 }}>
      <div className="ahp-shimmer" style={{ height: 12, width: "52%", marginBottom: 8 }} />
      <div className="ahp-shimmer" style={{ height: 10, width: "28%" }} />
    </div>
    {[120, 90, 110, 140, 110, 100].map((w) => (
      <div key={w} style={{ width: w, padding: "0 10px" }}>
        <div className="ahp-shimmer" style={{ height: 18, width: "80%" }} />
      </div>
    ))}
    <div style={{ width: 44 }} />
  </div>
);

export default ShimmerRow;
